<template>
  <v-dialog
    v-model="isVisible"
    max-width="650px"
    scrollable
    @click:outside="closeModal"
    @keydown.esc="closeModal"
  >
    <v-card class="user-edit-info">
      <v-card-title class="d-flex justify-space-between text-lg text-primary pa-3">
        <span> Task </span>
        <span>
          <v-icon @click="closeModal">{{ icons.mdiClose }}</v-icon>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-12 pt-5">
        <v-form ref="accountForm" class="multi-col-validation custom-form">
          <v-row>
            <v-col cols="6" class="input-padding">
              <label class="text--primary text-xs2 required-mark">{{ 'Subject' }}</label>
              <v-autocomplete
                v-model="modalFormData.subject"
                :items="userOptions"
                data-cy="log-subject"
                outlined
                :rules="[required]"
                dense
                autocomplete="null"
                class="custom-input"
                placeholder="Subject"
              >
              </v-autocomplete>
            </v-col>

            <!-- <v-col cols="6" class="input-padding">
              <label class="text--primary text-xs2 required-mark">{{ 'Contact' }}</label>
              <autocomplete-view
                v-if="isVisibleContactName"
                :label="defaultContactName"
                @handleClose="isVisibleContactName = false"
              />
              <v-autocomplete
                v-else
                v-model="modalFormData.contact_id"
                :items="contactArray"
                :search-input.sync="contactSearch"

                data-cy="log-contact"
                outlined
                :rules="[required]"
                dense
                autocomplete="null"
                item-text="name"
                item-value="uuid"
                class="custom-input"
                placeholder="Contact"
                @update:search-input="processContactInput"

              >
                <template v-slot:item="data">
                  <v-list-item-title class="text-xs3">
                    <div>{{ data.item.name }}</div>
                    <div v-if="data.item.related_to" class="text-xs">
                      {{ data.item.related_to.name }}
                    </div>
                  </v-list-item-title>
                </template>
              </v-autocomplete>
            </v-col> -->

            <v-col cols="6">
              <label class="text--primary text-xs2 required-mark">{{ 'Date' }}</label>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="5"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="modalFormData.date"
                    data-cy="call-log-date"
                    :prepend-inner-icon="icons.mdiCalendar"
                    readonly
                    placeholder="Date"
                    :rules="[required]"
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="modalFormData.date"
                  data-cy="date-picker-log-date"
                  color="primary"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="input-padding">
              <label class="text--primary text-xs2 required-mark">{{ 'Comment' }}</label>
              <v-textarea
                v-model="modalFormData.comment"
                rows="2"
                data-cy="log-comment"
                placeholder="Comment"
                :rules="[required]"
                outlined
                dense
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="my-5">
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" small class="px-6 py-4" @click="updateLog">
          Update
        </v-btn>
        <v-btn outlined small class="pa-4" @click="closeModal"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import Toaster from '@core/utils/sweetToast'
import { mdiCalendar, mdiClockTimeFourOutline, mdiDatabaseSearch, mdiClose } from '@mdi/js'
import { required, emailValidator } from '@core/utils/validation'
import moment from 'moment'
import AutocompleteView from '@/components/shared-components/AutocompleteView.vue'
import useDebounce from '@/plugins/useDebounce'

export default {
  components: { AutocompleteView },
  props: {
    openLogModal: {
      type: Boolean,
      required: true,
    },
    modalForm: {
      type: Object,
      default: () => ({}),
    },
    contactArray: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const searchAccount = ref(null)
    const accountForm = ref(null)
    const menu2 = ref(false)
    const isVisibleContactName = ref(false)
    const defaultContactName = ref(null)
    const contactSearch = ref(null)

    const modalFormData = ref({})
    const loading = ref(false)
    const userOptions = ref([
      { text: 'Call', value: 0 },
      { text: 'Email', value: 1 },
      { text: 'Send Letter', value: 2 },
      { text: 'Send Quote', value: 3 },
      { text: 'Other', value: 4 },
    ])

    const { debounce } = useDebounce()


    // account variables

    const isVisible = computed({
      get: () => props.openLogModal,
      set: () => {
        return false
      },
    })

    const closeModal = () => {
      emit('close')
    }
    const stateInit = () => {
      // copy the userInfo object
      const state = JSON.parse(JSON.stringify(props.modalForm))
      modalFormData.value = {
        uuid: state.uuid,
        subject: state.subject,
        comment: state.comment,
        date: state.date ? moment(state.date).format('YYYY-MM-DD') : null,
        contact_id: state.contact_details?.contact_id,
      }

      defaultContactName.value = state.contact_details?.name
      isVisibleContactName.value = true
    }

    stateInit()

    const updateLog = () => {
      const isValid = accountForm.value.validate()
      if (!isValid) return
      const payload = {
        component: 'task-management/logs',
        objectId: modalFormData.value.uuid,
        object: { ...modalFormData.value },
      }
      loading.value = true
      store
        .dispatch(`common/${storeActions.UPDATE_BY_ID}`, payload)
        .then(({ data }) => {
          emit('fetchRecords')
          Toaster.success(data.message)
          emit('close')
          loading.value = false
        })
        .catch(() => {
          loading.value = false

          Toaster.error('An error occur, please try again later', 'warning')
        })
    }

    const processContactInput = () => {
      // emit event and fetch contact
      debounce(() => emit('fetchContacts', contactSearch.value), 800)
    }

    return {
      isVisible,
      isVisibleContactName,
      defaultContactName,
      accountForm,
      searchAccount,
      closeModal,
      AutocompleteView,
      contactSearch,
      processContactInput,
      required,
      emailValidator,
      updateLog,
      modalFormData,
      menu2,
      userOptions,
      loading,
      icons: {
        mdiCalendar,
        mdiClockTimeFourOutline,
        mdiDatabaseSearch,
        mdiClose,
      },
    }
  },
}
</script>
<style scoped lang="scss"></style>
